// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dialog-history"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M11 14C11 17.3137 13.6863 20 17 20C20.3137 20 23 17.3137 23 14C23 10.6863 20.3137 8 17 8C13.6863 8 11 10.6863 11 14Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M1 4H23M1 9H7M1 14H7M1 19H7","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17 12.336V13.9999L18.3333 15.3334M17 20C13.6863 20 11 17.3137 11 14C11 10.6863 13.6863 8 17 8C20.3137 8 23 10.6863 23 14C23 17.3137 20.3137 20 17 20Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dialog-history')
export default class DialogHistoryIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dialog-history',
    }
  }
}
